import { plateUI } from '../common/plateUI';
import { createMyPlugins, elementsPlugins } from './elementsPlugins';

export const basicNodesPlugins = createMyPlugins([...elementsPlugins], {
  components: plateUI,
});
